import { styled } from '@mui/styles';

export const StyledMobileStepNavigation = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 16px',
  background: theme.vars.palette.bigid?.gray200,
  height: 34,
  position: 'sticky',
  zIndex: 10,
  top: 0,

  [theme.breakpoints.up('sm')]: {
    display: 'none',
  },
}));
